/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React, { ReactNode, useState } from 'react';
import AnimateHeight from 'react-animate-height';
import { Card } from '@broadleaf/admin-components/dist/common';

export const FulfillmentCardContainer: React.FC<FulfillmentCardContainerProps> = ({
  children,
  header,
  hideLabel = 'hide',
  showLabel = 'show'
}) => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <Card className="FulfillmentCard">
      <Card.Header className="tw-relative tw-border-b tw-pb-4">
        {header}
        <button
          className="tw-absolute tw-right-4 tw-top-1 tw-flex-none tw-border-none tw-px-2 tw-py-2 tw-text-right tw-text-xs tw-uppercase tw-tracking-tight tw-text-gray-600 tw-outline-none hover:tw-text-gray-700 focus:tw-outline-none md:tw-top-auto"
          onClick={() => setIsOpen(isOpen => !isOpen)}
          type="button"
        >
          {isOpen ? hideLabel : showLabel}
        </button>
      </Card.Header>
      <AnimateHeight duration={400} height={isOpen ? 'auto' : 0}>
        {children}
      </AnimateHeight>
    </Card>
  );
};

export interface FulfillmentCardContainerProps {
  header: ReactNode;
  hideLabel: ReactNode;
  showLabel: ReactNode;
}

export default FulfillmentCardContainer;
